import { createReducer } from "@reduxjs/toolkit";
import type { BatchStudent } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { resetRetrieveEducationalAdvisorStudents, retrieveEducationalAdvisorStudents } from "./retrieve-educational-advisor-students";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<BatchStudent[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveEducationalAdvisorStudentsListReducer = createReducer(initialState, builder => {
  builder
    .addCase(retrieveEducationalAdvisorStudents.pending, state => {
      state.fetching = "pending";
    })
    .addCase(retrieveEducationalAdvisorStudents.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(retrieveEducationalAdvisorStudents.rejected, state => {
      state.fetching = "failed";
      state.data = [];
    })
    .addCase(resetRetrieveEducationalAdvisorStudents, () => initialState);
});
